"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sourcingFeatures = ["Advanced UV resistance prevents fading in the harsh California sun.", "Moisture-shield technology eliminates warping and coastal wood rot.", "Eco-friendly materials made from 95% recycled wood and plastic.", "Low-maintenance finish—no seasonal staining or sealing ever required."];
export default function CommoditySourcing() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="210975" id="why-choose-composite-trex-decks" className="py-24 bg-background text-foreground overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`overflow-hidden rounded-sm shadow-lg aspect-video transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/global_commodity_logistics.png" alt="Close-up macro shot showing the grain texture of Trex composite decking" className="w-full h-full object-cover" />
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-6 md:p-8 transition-all duration-1000 ease-out delay-200 ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <h2 className="font-default font-bold text-4xl text-secondary tracking-tight">
              The Trex Advantage for California Coasts
            </h2>
            
            <p className="font-default font-normal text-base text-foreground">
              PCH Builders specializes in Trex installation, the premier choice for San Francisco and Monterey Bay homeowners. Engineered to withstand intense UV exposure and coastal humidity, these decks offer unrivaled durability and a refined aesthetic that outlasts traditional wood.
            </p>
            
            <ul className="list-disc pl-5 space-y-2">
              {sourcingFeatures.map((feature, i) => <li key={i} data-index={i} className="font-default font-medium text-base text-foreground hover:text-primary transition-colors duration-200">
                  {feature}
                </li>)}
            </ul>

            <div className="pt-4">
              <Button variant="default" size="lg" className="w-fit rounded-sm shadow-md">
                Get a Free Estimate: (925) 529-5005
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}